import * as React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Constants } from "../../constants";

class ConfirmModal extends React.Component<any,any> {
  constructor(props:any) {
    super(props);
    this.state = {
      modal: false,
      nestedModal: false,
      closeAll: false
    };

    this.toggle = this.toggle.bind(this);
    this.onConfirmAction = this.onConfirmAction.bind(this);
    this.onCancleAction = this.onCancleAction.bind(this);
  }

  toggle() { 

    let s = this.state.modal;
    this.setState({
      modal: !s
    });
  }

  onConfirmAction(){
    this.props.onConfirm();
    this.toggle();
  }

  onCancleAction(){
    this.props.onCancel();
    this.toggle();
  }

  render() {
    return (
      <div className={this.props.groupClassName}>
        <Button color="primary" active={true} onClick={this.toggle}>{Constants.MODAL_SAVEBANK_BUTTON}</Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} fade={false}>
          <ModalHeader toggle={this.toggle}>{Constants.MODAL_SAVEBANK_TITLE}</ModalHeader>
          <ModalBody>
            {Constants.MODAL_SAVEBANK_QUEST}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onConfirmAction}>{Constants.MODAL_BUTTON_CONFIRM}</Button>{' '}
            <Button color="secondary" onClick={this.onCancleAction}>{Constants.MODAL_BUTTON_CANCEL}</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ConfirmModal;